// extracted by mini-css-extract-plugin
export default {"dashboard_col_3":"Dashboard_dashboard_col_3__2SnvS","dashboard_col_9":"Dashboard_dashboard_col_9__NNdiV","navbar_sticky":"Dashboard_navbar_sticky__I+1Tl"};